import { Box, Heading } from '@chakra-ui/react';
import { capitalize } from 'lodash';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { AccountSettingsModule } from 'components/widgets/AccountSettings/layout/AccountSettingsModule';
import { AccountSettingsSection } from 'components/widgets/AccountSettings/layout/AccountSettingsSection';
import { useClient } from 'hooks/useClients';
import { useUser } from 'state/auth';

export const Billing = () => {
  const { user } = useUser();
  const billingDetails = useClient(String(user?.company_id));

  return (
    <AccountSettingsSection title="Billing">
      <FlexColumn sx={{ gap: 'padding_24' }}>
        <AccountSettingsModule title="Subscription">
          <Box display="flex" flexDirection="row" justifyContent="space-between">
            <Box>
              <Heading as="h3" size="sm">
                Start Date
              </Heading>
              <Box>{billingDetails.result?.data.contract_start || '-'}</Box>
            </Box>
            <Box ml="6">
              <Heading as="h3" size="sm">
                End Date
              </Heading>
              <Box>{billingDetails.result?.data.contract_end || '-'}</Box>
            </Box>
            <Box ml="6">
              <Heading as="h3" size="sm">
                Billing Cycle
              </Heading>
              <Box>{capitalize(billingDetails.result?.data.billing_cycle)}</Box>
            </Box>
          </Box>
        </AccountSettingsModule>

        <AccountSettingsModule title="Billing Details">
          <Box>
            <Heading as="h3" size="sm">
              Billing Contact
            </Heading>
            <Box>{billingDetails.result?.data.billing_contact || '-'}</Box>
          </Box>
          <Box mt="8" />
          <Box>
            <Heading as="h3" size="sm">
              Account Representative
            </Heading>
            <Box>{billingDetails.result?.data.account_rep_contact || '-'}</Box>
          </Box>
        </AccountSettingsModule>
      </FlexColumn>
    </AccountSettingsSection>
  );
};
